export enum ModulesEnum {
    Normal = 'Normaal',
    SwimmingPool = 'Zwembaden',
    SportsBuilding = 'Sportgebouwen',
    Gwp = 'GWP',
    Hnn = 'HNN'
}

